"use strict";

/**
 * Show ad inside video list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Other conditions are specified in the view file. 
   * If they are not fulfilled, then there will be no ".improveADS" element
   * 
   * @returns {boolean}
   */
  function isEnabled() {
    var _Flix$routeArgs$sort, _Flix$routeArgs$page;
    return Flix.ads.enabled
    /** Show only on the home page */ && Flix.currentRouteId == 'controllers.video.home'
    /** Only with default "featured" sort */ && ((_Flix$routeArgs$sort = Flix.routeArgs['sort']) !== null && _Flix$routeArgs$sort !== void 0 ? _Flix$routeArgs$sort : 'featured') == 'featured'
    /** Only on the 1st page */ && ((_Flix$routeArgs$page = Flix.routeArgs['page']) !== null && _Flix$routeArgs$page !== void 0 ? _Flix$routeArgs$page : 1) == 1
    // Should be enough videos in the list
    && !!document.querySelector('.video-list [data-num="10"]');
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    var token = Flix.isTna() ? '333efd65e8e0294a5c19413d03aadc56f799572fca15f910270dff207919d8ad' : '333efd65e8e0294a5c19413d03aadc56f799572fca15f910270dff207919d8ad';
    FlixUtils.request("https://stripchat.com/api/external/v4/widget?userId=".concat(token, "&limit=4"), {
      responseType: 'json'
    }).then(function (data) {
      var index = Math.floor(Math.random() * 3);
      var href = '//go.stripchat.com/?userId=333efd65e8e0294a5c19413d03aadc56f799572fca15f910270dff207919d8ad&path=' + encodeURI(data.models[index].username) + '&action=signUpModalDirectLinkInteractive&targetDomain=tnaflixchat.com&campaignId=NativeMobile';
      var height = document.querySelector('.video-thumb img').clientHeight;
      var style = "style=\"-webkit-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2);-moz-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2);box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2);\"";
      var html = "<div data-nosnippet class=\"col-xs-6 col-md-4 col-xl-3 mb-3\" ".concat(style, ">\n                    <a class=\"thumb video-thumb bg-dark\" href=\"").concat(href, "\" target=\"_blank\">\n                        <img style=\"height:").concat(height, "px; width:100%;\" src=\"").concat(data.models[index].snapshotUrl, "\" onerror=\"this.src='").concat(data.models[index].previewUrlThumbSmall, "'\" alt=\"Teen ").concat(data.models[index].username, " Playing on camera\"/>\n                        <div class=\"thumb-icon video-duration\">").concat(Math.floor(Math.random() * 30 + 10), ":").concat(Math.floor(Math.random() * 30 + 10), "</div>\n                        <div class=\"thumb-icon max-quality\">Sponsored video</div>\n                    </a>\n                    <a href=\"").concat(href, "\" target=\"_blank\" class=\"video-title\">Nice ").concat(data.models[index].username, " wants to play with you on cam</a>\n                </div>");
      document.querySelector('.video-list [data-num="10"]').insertAdjacentHTML('afterend', html);
    })["catch"](function (err) {
      return FlixStats.increment('ad_error_cams');
    });
  }
})();